export const MNuArray = [
    {
        name: 'Home',
        icon: 'fa-home',
        route: 'HOME_',
        code: 'HOME',
    },
    {
        name: 'ASMX Categorization',
        icon: 'fa-cassette-betamax',
        route: 'ASSET.CONFIG_',
        code: 'ASMX',
    },
    {
        name: 'Managed Accounts',
        icon: 'fa-id-badge',
        route: 'USER.MNGD_',
        code: 'USER_MANAGED',
    },
    {
        name: 'User Metadata',
        icon: 'fa-id-badge',
        route: 'USER.ATTR_',
        code: 'USER_ATTR',
    },
    {
        name: 'People Profile',
        icon: 'fa-id-badge',
        route: 'PEOPLE_PROFILE',
        code: 'IDAM.PEOPLE_PROFILE',
    },
    {
        name: 'Auth Providers',
        icon: 'fa-id-badge',
        route: 'IDAM.CONFIG_',
        code: 'PR0VIDERS',
    },
    {
        name: 'Log Xplorer',
        icon: 'fa-file-lines',
        route: 'L0GXP.SEARCH_',
        code: 'L0GXP',
    },
    {
        name: 'Help Center',
        icon: 'fa-life-ring',
        route: 'ASSET.REGISTRY_',
        code: 'HELP',
    },
]